import { IOnFilter, IOnSort } from "us.common/components";
import { appInsights } from "us.helper";

/**
 * @function
 * @description - sorting function on table tree
 * @param sortData - data sorting function
 * @param dataSource - data source with children data
 * @returns sorted data
 */
export const handleSortGroup: IOnSort = (sortData, dataSource) => {
  try {
    return sortData(
      dataSource.map((dataItem: any) => {
        return {
          ...dataItem,
          children: sortData(dataItem.children),
        };
      })
    );
  } catch (error) {
    appInsights.trackException(`creditor sorting Exception - ${error}`);
    return dataSource;
  }
};

/**
 * @function
 * @description - filtering function on table tree
 * @param searchData - data searching function
 * @param dataSource - data source with children data
 * @returns filtered data
 */
export const handleFilterGroup: IOnFilter = (searchData, dataSource) => {
  const result: any[] = [];
  try {
    dataSource.flatMap((dataItem: any) => {
      searchData(dataItem?.children)?.length != 0 &&
        result.push({
          ...dataItem,
          children:
            searchData(dataItem?.children)?.length == 0
              ? []
              : searchData(dataItem?.children),
        });
    });
    return result;
  } catch (error) {
    appInsights.trackException(`creditor filtering Exception - ${error}`);
  }
  return result;
};
